export default "__VITE_ASSET__C1m4goT___"